/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-bind */
// TODO: refactor this module to meet 'no-nested-ternary', 'react/jsx-no-bind' rule
import React, { Component } from 'react';
import moment from 'moment';
import { DatePicker } from 'antd';
import update from 'immutability-helper';

import i18n from '../../config/i18n';
import MedicationRow from './MedicationRow';
import RecommendationHeader from './RecommendationHeader';
import { PatientAPIConnectors } from '../../api';
import { DOCTOR_ID, PHARMACIST_ID, DIETITIAN_ID } from '../../constants/RoleConstants';

const styles = {
  trheader: {
    backgroundColor: '#FBFBFB',
  },
};

class WoundRecommendation extends Component {
  constructor(props) {
    super(props);
    const { nextVisit, note, pharmacistNote, dietitianNote, medication, id } = this.props;
    this.state = {
      nextVisit: nextVisit ? moment(nextVisit) : null,
      note: note || '',
      pharmacistNote: pharmacistNote || '',
      dietitianNote: dietitianNote || '',
      medication: medication || {},
      backupMedication: medication || {},
      id,
      isEditing: false,
    };


    this.handleRowDosage = this.handleRowDosage.bind(this);
    this.handleChangeMedication = this.handleChangeMedication.bind(this);
    this.handleFrequencyA = this.handleFrequencyA.bind(this);
    this.handleFrequencyB = this.handleFrequencyB.bind(this);
    this.handleClickDelete = this.handleClickDelete.bind(this);
    this.handleNextVisitChange = this.handleNextVisitChange.bind(this);
    this.handleAddMedication = this.handleAddMedication.bind(this);
    this.handleUpdateRecommendation = this.handleUpdateRecommendation.bind(this);
    this.edit = this.edit.bind(this);
    this.cancel = this.cancel.bind(this);
  }

  setInputsToDefaultValues() {
    const {
      nextVisit,
      note,
      pharmacistNote,
      dietitianNote,
      id,
    } = this.props;
    this.setState({
      nextVisit: nextVisit ? moment(nextVisit) : null,
      note: note || '',
      dietitianNote: dietitianNote || '',
      pharmacistNote: pharmacistNote || '',
      medication: this.state.backupMedication,
      id,
      isEditing: false,
    });
  }

  handleAddMedication() {
    const obj = {};
    const time = moment().valueOf();
    obj[time] = {};
    const newMedication = update(this.state.medication, { $merge: obj });
    this.setState({ medication: newMedication });
  }

  handleUpdateRecommendation() {
    const recommendation = { ...this.state };
    const { assessmentId } = this.props;
    const { id } = this.state;

    delete recommendation.id;
    delete recommendation.isEditing;
    delete recommendation.backupMedication;

    PatientAPIConnectors.updateRecommendation(recommendation, assessmentId, id)
      .then((data) => {
        this.props.actions.createSuccessAlert(i18n.t('updateRecommendationSucceedMsg'));
        this.setState({
          id: data.id,
          isEditing: !this.state.isEditing,
          backupMedication: data.medication,
        });
      })
      .catch((err) => {
        this.props.actions.createAlert(err);
        this.setInputsToDefaultValues();
        this.setState({ isUpdating: false });
      });
  }

  handleNoteChange(key, e) {
    this.setState({ [key]: e.target.value });
  }

  handleNextVisitChange(date) {
    this.setState({ nextVisit: date });
  }

  handleChangeMedication(value, medicationId) {
    const newMedication = { ...this.state.medication };
    newMedication[medicationId].medication = value;
    this.setState({ medication: newMedication });
  }

  handleRowDosage(dosage, medicationId) {
    const newMedication = { ...this.state.medication };
    newMedication[medicationId].dosage = dosage;
    this.setState({ medication: newMedication });
  }

  handleFrequencyA(value, medicationId) {
    const newMedication = { ...this.state.medication };
    newMedication[medicationId].frequencyA = value;
    this.setState({ medication: newMedication });
  }

  handleFrequencyB(value, medicationId) {
    const newMedication = { ...this.state.medication };
    newMedication[medicationId].frequencyB = value;
    this.setState({ medication: newMedication });
  }

  handleClickDelete(medicationId) {
    const newMedication = { ...this.state.medication };
    delete newMedication[medicationId];
    this.setState({ medication: newMedication });
  }

  cancel() {
    this.setState({ isEditing: false });
    this.setInputsToDefaultValues();
  }

  edit() {
    this.setState({ isEditing: !this.state.isEditing });
  }

  parseRecommendationBodyFirstRow = (isDoctor, nextVisit, note, isEditing) => (
    <tr>
      <th>
        {i18n.t('nextVisitDate')}
      </th>
      <td>
        {
          isDoctor && isEditing ? (
            <DatePicker
              value={nextVisit}
              disabledDate={date => date && date <= moment().endOf('day')}
              onChange={this.handleNextVisitChange}
            />
          ) : (
            nextVisit ? nextVisit.format('YYYY/MM/DD') : ''
          )
        }
      </td>
      <th>
        {i18n.t('notes_treatments')}
      </th>
      <td>
        {
          (isDoctor && isEditing) ? (
            <textarea
              className="form-control"
              placeholder={i18n.t('note')}
              value={note}
              onChange={this.handleNoteChange.bind(this, 'note')}
            />
          ) : (
            note
          )
        }
      </td>
    </tr>
  );

  parseRecommendationBodySecondRow = (
    user, p_id, d_id, pharmacistNote, dietitianNote, isEditing
  ) => (
    <tr>
      <th>
        {i18n.t('pharmacistRecommendations')}
      </th>
      <td>
        {
          user.profile.roleId === p_id && isEditing ?
            <textarea
              className="form-control"
              placeholder={i18n.t('pharmacistNote')}
              value={pharmacistNote}
              onChange={this.handleNoteChange.bind(this, 'pharmacistNote')}
            /> : pharmacistNote
        }
      </td>
      <th>
        {i18n.t('dietitianRecommendations')}
      </th>
      <td>
        {
          user.profile.roleId === d_id && isEditing ?
            <textarea
              className="form-control"
              placeholder={i18n.t('dietitianNote')}
              value={dietitianNote}
              onChange={this.handleNoteChange.bind(this, 'dietitianNote')}
            /> : dietitianNote
        }
      </td>
    </tr>
  );

  parseRecommendationMedicationHeader = () => (
    <tr style={styles.trheader}>
      <th>{i18n.t('medications')}</th>
      <th>{i18n.t('dressingChangeFrequencyA')}</th>
      <th>{i18n.t('dressingChangeFrequencyB')}</th>
      <th>{i18n.t('recommendedDosage')}</th>
    </tr>
  );

  parseMedicationsRows(medications, metadata, isEditing) {
    const {
      user: {
        profile: {
          roleId: userRoleId,
        },
      },
    } = this.props;

    if (medications === undefined || Object.keys(medications).length === 0) {
      return null;
    }
    // dietitians and pharmacists shouldn't be able to edit the medication rows
    return Object.keys(medications).map(key => ((
      <MedicationRow
        key={key}
        medication={medications[key]}
        medicationId={key}
        onChangeDosage={this.handleRowDosage}
        onChangeMedications={this.handleChangeMedication}
        onChangeFrequencyA={this.handleFrequencyA}
        onChangeFrequencyB={this.handleFrequencyB}
        onClickDelete={this.handleClickDelete}
        metadata={metadata}
        isEditing={isEditing && userRoleId !== DIETITIAN_ID && userRoleId !== PHARMACIST_ID}
      />
    )));
  }

  render() {
    const {
      user,
      metadata,
    } = this.props;
    const {
      medication,
      isEditing,
      nextVisit,
      note,
      pharmacistNote,
      dietitianNote,
    } = this.state;
    const isDoctor = user.profile.roleId === DOCTOR_ID;
    const medicationsRows = this.parseMedicationsRows(medication, metadata, isEditing);
    const recommendationBodyFirstRow = this.parseRecommendationBodyFirstRow(
      isDoctor, nextVisit, note, isEditing
    );
    const recommendationBodySecondRow = this.parseRecommendationBodySecondRow(
      user, PHARMACIST_ID, DIETITIAN_ID, pharmacistNote, dietitianNote, isEditing
    );
    const recommendationMedicationHeader = this.parseRecommendationMedicationHeader();
    return (
      <table className="table table-bordered table-responsive patient">
        <RecommendationHeader
          user={user}
          isEditing={isEditing}
          handleAddMedication={this.handleAddMedication}
          handleUpdateRecommendation={this.handleUpdateRecommendation}
          edit={this.edit}
          cancel={this.cancel}
        />
        <tbody>
          {recommendationBodyFirstRow}
          {recommendationBodySecondRow}
          {recommendationMedicationHeader}
          {medicationsRows}
        </tbody>
      </table>
    );
  }
}

export default WoundRecommendation;



// WEBPACK FOOTER //
// ./src/components/patient/WoundRecommendation.js